import React, { Fragment } from "react";
import Nav from "../Component/Nav";
import Footer from "../Component/Footer";

export default function Terms() {
    return (
        <Fragment>
            <Nav />
            <div className="container mt-5 mb-5">
                <div className="row">
                    <div className="col-12">
                        <h1 className="text-center mb-4">Terms of Service</h1>
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h3>1. Introduction</h3>
                                <p>Welcome to Smart Brain. By accessing our website and using our services, you agree to comply with and be bound by the following terms and conditions.</p>

                                <h3>2. User Agreement</h3>
                                <p>By using our platform, you represent that you are at least 18 years old or visiting under the supervision of a parent or guardian.</p>

                                <h3>3. Intellectual Property</h3>
                                <p>All content included on this site, such as text, graphics, logos, images, and software, is the property of Smart Brain or its content suppliers.</p>

                                <h3>4. Payment and Refunds</h3>
                                <p>All payments are processed securely. We offer a 30-day money-back guarantee on most courses, subject to our refund policy.</p>

                                <h3>5. Limitation of Liability</h3>
                                <p>Smart Brain shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from the use or inability to use our services.</p>

                                <h3>6. Changes to Terms</h3>
                                <p>We reserve the right to modify these terms at any time. Please review this page periodically for changes.</p>

                                <p className="mt-4 text-muted">Last updated: {new Date().toLocaleDateString()}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </Fragment>
    );
}